module.exports = __webpack_public_path__ + "static/media/[Lectures_and_Panels]2014-09-30.0ddfffc9.md";